package gr.tech.site.styles.states

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.functions.invert
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import gr.tech.site.styles.Theme
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.JustifyContent

// UTILITY PARTNER CARD

val UtilityPartnerWrapperStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Block)
            .position(Position.Relative)
            .height(100.percent)
            .margin(bottom = 16.px)
    }
    // Pop the whole wrapper above surrounding rows so the drawer isn't clipped
    hover {
        Modifier.zIndex(10)
    }
    cssRule(":hover .utility-card") {
        Modifier
            .translateY((-4).px)
            .boxShadow(
                BoxShadow.of(
                    offsetX = 0.px,
                    offsetY = 8.px,
                    blurRadius = 24.px,
                    spreadRadius = 0.px,
                    color = rgba(2, 67, 66, 0.25)
                )
            )
    }
    cssRule(":hover .utility-drawer") {
        Modifier.translateY((-30).percent)
    }
}

val UtilityPartnerCardStyle = CssStyle.base {
    Modifier
        .display(DisplayStyle.Flex)
        .flexDirection(FlexDirection.Column)
        .justifyContent(JustifyContent.Center)
        .alignItems(AlignItems.Center)
        .backgroundColor(Colors.White)
        .borderRadius(12.px)
        .border(2.px, LineStyle.Solid, Theme.MediumGreen.rgb)
        .overflow(Overflow.Hidden)
        .position(Position.Relative)
        .zIndex(1)
        .width(100.percent)
        .height(100.percent)
        .minHeight(90.px)
        .padding(topBottom = 16.px, leftRight = 10.px)
        .transition(Transition.all(250.ms))
        .cursor(Cursor.Pointer)
}

val UtilityPartnerLogoStyle = CssStyle.base {
    Modifier
        .width(100.percent)
        .height(80.px)
        .objectFit(ObjectFit.Contain)
        .padding(topBottom = 1.cssRem, leftRight = 1.5.cssRem)
}

val UtilityPartnerContentStyle = CssStyle.base {
    Modifier
        .padding(leftRight = 1.5.cssRem, bottom = 1.5.cssRem)
        .flexGrow(1)
}

val UtilityPartnerDrawerStyle = CssStyle {
    base {
        Modifier
            .position(Position.Absolute)
            .top(100.percent)
            .left((0).px)
            .right((0).px)
            .zIndex(0)
            .backgroundColor(Theme.MediumGreen.rgb)
            .color(Colors.White)
            .borderRadius(0.px, 0.px, 12.px, 12.px)
            .padding(top = 1.75.cssRem, bottom = 1.cssRem, leftRight = .5.cssRem)
            .translateY((-25).percent)
            .transition(Transition.all(300.ms))
            .textAlign(TextAlign.Center)
            .fontSize(0.875.cssRem)
            .fontWeight(600)
            //.whiteSpace(WhiteSpace.NoWrap)
    }
    Breakpoint.MD {
        Modifier.translateY((-100).percent)
    }
}

// STATS SECTION
val StateStatIconStyle = CssStyle.base {
    Modifier
        .fontSize(3.cssRem)
        .fontWeight(800)
        .color(Theme.MediumGreen.rgb)
        .margin(bottom = 1.cssRem)
}

val StateStatNumberStyle = CssStyle.base {
    Modifier
        .fontSize(3.cssRem)
        .fontWeight(800)
        .color(Theme.DarkGreen.rgb)
        .lineHeight(1.1)
        .margin(bottom = 0.25.cssRem)
}

val StateStatLabelStyle = CssStyle.base {
    Modifier
        .fontSize(1.cssRem)
        .fontWeight(500)
        .color(Theme.DarkGreen.rgb)
        .opacity(80.percent)
}

// FAQ ACCORDION

val FaqAccordionStyle = CssStyle {
    cssRule(" .accordion-item") {
        Modifier
            .backgroundColor(Colors.Transparent)
            .border(1.px, LineStyle.Solid, rgba(255, 255, 255, 0.15))
    }
    cssRule(" .accordion-button") {
        Modifier
            .backgroundColor(Theme.DarkGreen.rgb)
            .color(Colors.White)
            .fontWeight(600)
            .fontSize(1.cssRem)
    }
    cssRule(" .accordion-button:not(.collapsed)") {
        Modifier
            .backgroundColor(rgba(255, 255, 255, 0.08))
            .color(Colors.White)
    }
    // Invert Bootstrap's default dark chevron so it reads as white on dark bg
    cssRule(" .accordion-button::after") {
        Modifier.filter(invert(100.percent))
    }
    cssRule(" .accordion-collapse") {
        Modifier.backgroundColor(Colors.Transparent)
    }
    cssRule(" .accordion-body") {
        Modifier
            .color(Colors.White)
            .opacity(80.percent)
            .fontSize(0.95.cssRem)
            .lineHeight(1.7)
    }
}
